import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../styles/Login.css';

const ForgotPassword = ({ lang }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState({ type: '', text: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg({ type: '', text: '' });
    setLoading(true);
    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'An error occurred');
      setMsg({
        type: 'success',
        text: data.message || (lang.FORGOT_SUCCESS || 'If the email exists in our system, a password reset link has been sent.')
      });
    } catch (err) {
      setMsg({ type: 'error', text: err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="login-page">
      <div className="container">
        <motion.div
          className="login-wrapper"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="login-left">
            <div className="login-brand">
              <span className="login-terminal-line">
                {lang.FORGOT_TERMINAL || 'root@ispclub:~/# ./ispclub --member -forgotpw'}
              </span>
              <h1 className="login-title">{lang.FORGOT_TITLE || 'Forgot Password'}</h1>
              <p className="login-desc">
                {lang.FORGOT_DESC || 'Enter your registered email and we will send you a link to reset your password.'}
              </p>
            </div>
          </div>

          <div className="login-right">
            <form className="login-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="email">{lang.FORGOT_EMAIL || 'Email'}</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder={lang.FORGOT_EMAIL_PLACEHOLDER || 'your@email.com'}
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary login-submit"
                disabled={loading}
              >
                {loading ? (lang.FORGOT_SENDING || 'Sending...') : (lang.FORGOT_SUBMIT || 'Send reset link')}
              </button>

              {msg.text && (
                <div className={`forgot-msg ${msg.type}`}>{msg.text}</div>
              )}

              <Link to="/login" className="login-back-link">
                ← {lang.FORGOT_BACK || 'Back to login'}
              </Link>
            </form>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ForgotPassword;
